import React from 'react';
import PropTypes from 'prop-types';
import throttle from 'lodash.throttle';
import { browserSupports } from '@prisjakt/ui-base';

const ViewportContext = React.createContext();
ViewportContext.displayName = 'ViewportContext';

class ViewportTracker extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      viewport: {
        width: 0,
        height: 0,
        left: 0,
        top: 0,
        scroll: {
          xDirection: undefined,
          yDirection: undefined,
          x: -0,
          y: -0,
        },
      },
    };

    const THROTTLE = 200;

    this.onUpdateViewport = this.onUpdateViewport.bind(this);

    this.throttledOnUpdateViewport = throttle(this.onUpdateViewport, THROTTLE);
  }

  componentDidMount() {
    window.addEventListener(
      'scroll',
      this.throttledOnUpdateViewport,
      browserSupports.passiveEventListener() ? { passive: true } : false
    );
    window.addEventListener('resize', this.throttledOnUpdateViewport);

    requestAnimationFrame(this.onUpdateViewport, 0);
    this.onUpdateViewport();
  }

  componentWillUnmount() {
    window.removeEventListener(
      'scroll',
      this.throttledOnUpdateViewport,
      browserSupports.passiveEventListener() ? { passive: true } : false
    );
    window.removeEventListener('resize', this.throttledOnUpdateViewport);
  }

  onUpdateViewport(e) {
    const html = document.documentElement;
    const x = (e && e.scrollX) || window.scrollX;
    const y = (e && e.scrollY) || window.scrollY;
    const scrollChanged =
      x !== this.state.viewport.scroll.x || y !== this.state.viewport.scroll.y;
    const scroll = scrollChanged
      ? {
          xDirection: Math.sign(this.state.viewport.scroll.x - x),
          yDirection: Math.sign(this.state.viewport.scroll.y - y),
          x,
          y,
        }
      : this.state.viewport.scroll;
    this.setState({
      viewport: {
        width: window.innerWidth || html.clientWidth,
        height: window.innerHeight || html.clientHeight,
        left: window.pageXOffset || html.scrollLeft,
        top: window.pageYOffset || html.scrollTop,
        scroll,
      },
    });
  }

  render() {
    return (
      <ViewportContext.Provider value={this.state.viewport}>
        {this.props.children}
      </ViewportContext.Provider>
    );
  }
}

ViewportTracker.propTypes = {
  children: PropTypes.node,
};

ViewportTracker.defaultProps = {
  children: null,
};

export const ViewportContextConsumer = ViewportContext.Consumer;

export const withViewport = Component => props => (
  <ViewportContextConsumer>
    {viewport => <Component {...props} viewport={viewport} />}
  </ViewportContextConsumer>
);

export default ViewportTracker;
